<template>
  <main-layout
    class="aviatFarming"
    custom-back
    page-title="种源管理"
    @listen-back="goBack"
  >
    <div slot="main-content" class="aviatFarming-content">
      <div v-if="activeName === 'first'" class="aviatFarming-box">
        <!-- 筛选条件 -->
        <div class="aviatFarming-form">
          <div class="aviatFarming-form-div-avix">
            <el-select
              v-model="queryForm.cropSubjectNameid"
              placeholder="全部分类"
              size="medium"
              @change="handleChangemissionCate"
            >
              <el-option
                v-for="item in missionCategoryList"
                :key="item.id"
                :label="item.cropSubjectName"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select
              v-if="queryForm.cropSubjectNameid"
              v-model="queryForm.listCropCategoryid"
              clearable
              placeholder="请选择小类"
              size="medium"
              @change="handleChangecropSubject"
            >
              <el-option
                v-for="item in listCropCategoryList"
                :key="item.id"
                :label="item.cropCategoryName"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select
              v-if="queryForm.listCropCategoryid"
              v-model="queryForm.cropId"
              clearable
              filterable
              placeholder="请选择分类"
              remote
              size="medium"
              @change="handleChange"
            >
              <el-option
                v-for="item in cropNameList"
                :key="item.id"
                :label="item.cropName"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="aviatFarming-form-div aviatFarming-form-date">
            <el-date-picker
              v-model="queryForm.date"
              :clearable="false"
              class="seedPicker"
              end-placeholder="结束日期"
              range-separator="至"
              size="medium"
              start-placeholder="开始日期"
              type="daterange"
              value-format="yyyy-MM-dd"
              @change="handleChange"
            >
            </el-date-picker>
          </div>
          <div class="aviatFarming-form-div">
            <el-input
              v-model="queryForm.productName"
              placeholder="种源搜索"
              size="medium"
              @input="handleChange"
            >
            </el-input>
          </div>
          <div class="aviatFarming-form-btn">
            <el-button size="medium" type="primary" @click="autoReview(7)"
              >新增种源
            </el-button>
            <!-- <el-button
              size="medium"
              class="export-btn"
              v-if="isShowExport"
              :disabled="!dataList.length || !multipleSelection.length"
              >导出</el-button
            > -->
          </div>
        </div>
        <!-- 列表 -->
        <TableList
          ref="tabList"
          :is-show="!!dataList.length"
          :list="dataList"
          :loading="tableLoading"
          class="tablelist"
          @selectListChange="selectListChange"
          @updateList="updateList"
        >
        </TableList>
        <!-- 分页 -->
        <pagiation
          v-show="!!dataList.length"
          :pageNo="queryForm.pageNo"
          :pageSize="queryForm.pageSize"
          :pagisShow="!!dataList.length"
          :total="total"
          @currentChange="currentChange"
        />
      </div>
      <!-- 全选、批量操作 -->
      <div class="aviatFarming-footer-tools">
        <div>
          <el-checkbox
            v-model="checkAll"
            :disabled="!dataList.length"
            size="medium"
            @change="handleCheckAllChange"
          >
            全选
            <span v-if="checkAll">{{ multipleSelection.length }}条</span>
            <span v-if="isIndeterminate"
              >选中{{ multipleSelection.length }}条</span
            >
          </el-checkbox>
          <el-button
            v-if="isShowBatchDel"
            :disabled="!dataList.length"
            round
            size="mini"
            @click="batchDelete"
            >批量删除
          </el-button>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import TableList from "./TableList/index";
import Pagiation from "@/components/Pagiation.vue";
import { windowHref } from "@/utils";
import { getStorage } from "@/utils/storage";
import { mapActions } from "vuex";
import {
  deleteByIds,
  seedSourcePageList,
  listAll,
  listCropCategory,
  selectList,
} from "@/api/request/snkd.produce";

export default {
  name: "AviatFarmingList",
  components: {
    MainLayout,
    TableList,
    Pagiation,
  },

  data() {
    return {
      activeName: "first",
      tableLoading: false,
      companyId: "",
      farmId: "",
      queryForm: {
        productName: "",
        cropId: "",
        listCropCategoryid: "",
        cropSubjectNameid: 1,
        date: [],
        pageNo: 1,
        pageSize: 20,
      },
      total: 0,
      missionCategoryList: [], // 农事类型
      listCropCategoryList: [],
      cropNameList: [],
      dataList: [],
      checkAll: false,
      isIndeterminate: false,
      multipleSelection: [], //表格勾选的数据
      //是否显示7天、3天自动审核按钮
      isShowAutoExamine: false,
      //是否显示导出按钮
      isShowExport: false,

      //是否显示批量删除按钮
      isShowBatchDel: false,
      //是否显示批量审核按钮
      isShowBatchExamine: false,
      pickerDateOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  async mounted() {
    //初始化时间
    // let startDate =
    //   new Date().getFullYear() + "-" + new Date().format("MM") + "-01";
    // let endDate = new Date().format("yyyy-MM-dd");
    // this.queryForm.date = [startDate, endDate];
    this.handleChangemissionCate();
    //获取农场id
    const farminfo = getStorage("FARMINFO");
    if (getStorage("FARMINFO")) {
      this.companyId = farminfo.companyId;
      this.farmId = farminfo.farmId;
    }
    await this.init();
    await this.fnHasPermission();
    await this.getTypeList();
    await this.getList();
  },
  methods: {
    listCropCategory,
    ...mapActions("permission", ["hasPermission"]),
    async getList() {
      this.tableLoading = true;
      let params = {
        ...this.queryForm,
        companyId: this.companyId,
        farmId: this.farmId,
        startDate: this.queryForm.date ? this.queryForm.date[0] : "",
        endDate: this.queryForm.date ? this.queryForm.date[1] : "",
      };

      await seedSourcePageList(params).then((res) => {
        const { respCode, obj } = res;
        if (respCode === 0) {
          this.dataList = obj.list || [];
          console.log(this.dataList, 9090);
          this.total = obj.totalCount;
        }
        this.tableLoading = false;
      });
    },
    async init() {
      try {
        let res = await listAll();
        if (res.obj.list && res.obj.list[0]) {
          this.missionCategoryList = res.obj.list;
        } else {
          this.missionCategoryList = [
            // {
            //   id: "",
            //   cropSubjectName: "全部分类",
            // },
          ];
        }
        console.log(res.obj.list);
      } catch (e) {
        console.log(e);
      }
    },
    async handleChangemissionCate() {
      try {
        let res = await listCropCategory(this.queryForm.cropSubjectNameid);
        this.queryForm.listCropCategoryid = "";
        this.queryForm.cropId = "";
        this.cropNameList = [];
        if (res.obj && res.obj[0]) {
          this.listCropCategoryList = res.obj;
        } else {
          this.listCropCategoryList = [
            // {
            //   id: "",
            //   cropCategoryName: "全部作物小类",
            // },
          ];
        }
      } catch (e) {
        console.log(e);
      }
    },
    async handleChangecropSubject() {
      try {
        let res = await selectList({
          pageNo: 1,
          pageSize: 9999,
          cropCategoryId: this.queryForm.listCropCategoryid,
        });
        this.queryForm.cropId = "";
        if (res.obj.list && res.obj.list[0]) {
          this.cropNameList = res.obj.list;
        } else {
          this.cropNameList = [];
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getTypeList() {
      // await getMissionCategoryList().then((res) => {
      //   const { respCode, obj } = res;
      //   if (respCode === 0) {
      //     let arr = obj || [];
      //     this.missionCategoryList.push(...arr);
      //   }
      // });
    },
    //更新列表
    updateList() {
      this.queryForm.pageNo = 1;
      this.getList();
    },
    //判断按钮是否有权限
    async fnHasPermission() {
      //批量删除
      this.isShowBatchDel = await this.hasPermission(
        "produce:navigateCultivate:batchDel"
      );
    },
    //批量删除
    batchDelete() {
      if (!this.multipleSelection.length) {
        this.$message({
          type: "info",
          message: "请勾选数据后再进行批量操作",
        });
        return false;
      }
      const h = this.$createElement;
      this.$confirm("", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirm-dialog",
        message: h("div", [
          h(
            "p",
            {
              style:
                "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
            },
            `是否进行批量删除？`
          ),
          h(
            "p",
            {
              style:
                "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
            },
            [
              h("span", null, "已选中"),
              h(
                "i",
                { style: "color: #FF0000" },
                `${this.multipleSelection.length}`
              ),
              h("span", null, "条数据，删除后的数据将无法恢复。"),
            ]
          ),
        ]),
        type: "warning",
      })
        .then(async () => {
          await deleteByIds({
            ids: this.multipleSelection.map((item) => item.id),
          }).then((res) => {
            const { respCode } = res;
            if (respCode === 0) {
              this.$message({
                type: "success",
                message: "批量删除成功！",
              });
              this.queryForm.pageNo = 1;
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    autoReview() {
      this.$router.push({
        path: "/addSeedSource",
      });
    },
    // 全选按钮切换
    handleCheckAllChange(val) {
      console.log("handleCheckAllChange", val, this.$refs.tabList);
      if (val) {
        //全选当前页
        this.$refs.tabList.$refs.multipleTable.toggleAllSelection();
      } else {
        //清空当前页选择数据
        this.$refs.tabList.$refs.multipleTable.clearSelection();
      }
      this.isIndeterminate = false;
    },
    // 表格选中数据切换
    selectListChange(rows) {
      this.multipleSelection = rows;
      let checkedLength = rows.length;
      this.checkAll = checkedLength === this.dataList.length;
      this.isIndeterminate =
        checkedLength > 0 && checkedLength < this.dataList.length;
    },
    // 页码切换
    currentChange(pageNo) {
      this.isIndeterminate = false;
      this.checkAll = false;
      this.multipleSelection = [];
      this.$refs.tabList.$refs.multipleTable.clearSelection();
      this.queryForm.pageNo = pageNo;
      this.getList();
    },
    handleChange() {
      // if (this.queryForm.date) {
      //   let startTime = new Date(this.queryForm.date[0]).getTime();
      //   let endTime = new Date(this.queryForm.date[1]).getTime();
      //   if (endTime - startTime > 31536000000) {
      //     this.$message({
      //       message: "起始日期和结束日期不能超过一年",
      //       type: "warning",
      //     });
      //     this.dataList = [];
      //     return false;
      //   }
      // }
      this.queryForm.pageNo = 1;
      this.getList();
    },
    goBack() {
      windowHref("/home/home");
    },
    //tab切换
    handleClick() {},
  },
};
</script>

<style lang="scss" scoped>
.aviatFarming {
  .aviatFarming-content {
    width: 1320px;
    height: 100%;
    background: #fff;
    margin: 0 auto;

    ::v-deep .aviatFarming-header {
      height: 68px;
      position: relative;

      .el-tabs,
      .el-tabs__header,
      .el-tabs__nav-wrap,
      .el-tabs__nav-scroll,
      .el-tabs__nav,
      .el-tabs__item {
        height: 100%;
        line-height: 68px;
      }

      .el-tabs__nav-scroll {
        padding-left: 20px;
      }

      .el-tabs__item {
        font-size: 22px;
        font-weight: 700;
      }

      &-txt {
        position: absolute;
        top: 28px;
        right: 37px;
        font-size: 12px;
        color: #000;
        font-weight: 400;
        cursor: pointer;

        span {
          color: #21c074;
        }
      }
    }

    .aviatFarming-box {
      .aviatFarming-form {
        padding: 32px 12px;
        display: flex;

        &-div {
          width: 180px;
          margin-left: 10px;
        }

        &-date {
          width: 250px;

          .el-date-editor {
            width: 100%;
          }
        }

        &-btn {
          flex: 1;
          text-align: right;

          .export-btn {
            border: 1px solid #64c3a4;
            color: #64c3a4;
          }
        }
      }
    }

    .aviatFarming-footer-tools {
      width: 100%;
      padding: 10px 14px;
      position: fixed;
      bottom: 0;
      left: 0;
      background: #fff;
      z-index: 2;

      > div {
        width: 1300px;
        margin: 0 auto;
      }

      .el-button {
        margin-left: 24px;
      }
    }
  }
}

::v-deep .el-table {
  height: 100%;

  .el-table__body-wrapper {
    position: relative;
    height: calc(100% - 80px);

    table {
      padding-bottom: 0 !important;
    }
  }

  .el-table__header-wrapper {
    th:first-child {
      .cell {
        width: 60px;

        .el-checkbox {
          display: none;
        }

        &:after {
          // content:'';
        }
      }
    }
  }
}

::v-deep .el-table {
  border: 0;

  th,
  tr,
  td {
    border: 0;
  }

  &::before {
    height: 0px;
  }
}

// 表格行样式
::v-deep .statistics-warning-row {
  background: $--color-tablist;
}

// 滚动条样式
::v-deep .bscroll-indicator {
  background-color: #dcdfe6 !important;
}

::v-deep .bscroll-vertical-scrollbar {
  z-index: 1 !important;
}

//表头高度
::v-deep .el-table__header tr,
.el-table__header th {
  height: 60px;
}

// 行背景色
::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fff !important;
}

::v-deep .el-table__row {
  height: 62px;
}

::v-deep .el-table td,
.el-table th.is-leaf {
  border: none;
}

// 表格最外边框
.el-table--border,
.el-table--group {
  border: none;
}

// 加载圈
::v-deep .el-loading-mask {
  z-index: 1;
}

//el-date-range-picker__content
</style>

<style lang="scss">
.confirm-dialog .el-message-box__status.el-icon-warning {
  top: 13px !important;
}

.confirm-dialog {
  width: 450px;
}

.el-date-range-picker__content {
  padding: 0 !important;

  .el-date-table {
    padding: 0 16px 16px !important;
    display: flex;

    tbody {
      display: flex;
      flex-direction: column;
      flex: 1;

      tr {
        display: flex;

        .in-range {
          div {
            background-color: #d5fff1 !important;
            border-radius: initial;

            span {
              border-radius: initial;
            }
          }
        }

        .end-date {
          div {
            margin-right: 0;
            background-color: #64c3a4 !important;
          }
        }

        .start-date {
          div {
            margin-left: 0;
            background-color: #64c3a4 !important;
          }
        }

        th,
        td {
          flex: 1;
        }
      }
    }
  }
}

.el-date-range-picker__header {
  padding: 0 16px;
  background-color: #64c3a4;
  color: #ffffff;
  height: 45px;
  line-height: 45px;

  .el-picker-panel__icon-btn {
    color: #ffffff;
    margin-top: 14px;
    font-size: 17px;
  }
}

.el-picker-panel {
  .popper__arrow {
    display: none;
  }
}

.aviatFarming-form-div-avix {
  display: flex;
}
</style>
